import 'amfe-flexible'
import Vue from 'vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import common from './utils/common'

Vue.use(Vant)
Vue.config.productionTip = false
// 公共方法
Vue.use(common)
// 地图配置config
Vue.prototype.WGmapConfig = mapConfig

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
